// extracted by mini-css-extract-plugin
export var horizontal = "Divider-module--horizontal--db64b";
export var horizontal_media_md = "Divider-module--horizontal_media_md--3c35a";
export var root = "Divider-module--root--d0701";
export var vertical = "Divider-module--vertical--5fcfb";
export var vertical_media_md = "Divider-module--vertical_media_md--ec103";